import React from 'react'
import PropTypes from 'prop-types'
import types from './types'
import styles from './category.module.scss'

const Category = (props) => {
  const { category } = props

  const renderText = (type) => {
    switch (type) {
      case types.PROBLEMS: {
        return 'Problemas'
      }
      case types.DOUBTS: {
        return 'Dúvidas'
      }
      case types.OFFER: {
        return 'Oferta'
      }
      case types.ACTION_PLAN: {
        return 'Plano de Ação'
      }
      default: {
        return 'Treinamento'
      }
    }
  }

  return (
    <div className={styles.timelineItemTag}>
      <span>{renderText(category)}</span>
    </div>
  )
}

Category.propTypes = {
  category: PropTypes.number.isRequired
}

export default Category
